/* Match the configured roll display's presentment conversion, not catalog sample pricing. */
(() => {
  function updatePrices() {
    const currency = window.Shopify?.currency;
    const rate = Number(currency?.rate);
    if (!currency?.active || !Number.isFinite(rate) || rate <= 0) return;
    let money;
    try {
      money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency.active
      });
    } catch { return; }
    document.querySelectorAll('[data-z-roll-start]').forEach(card => {
      const base = Number(card.dataset.zRollStart);
      const label = card.querySelector('[data-z-roll-start-price]');
      if (!label || !Number.isFinite(base) || base <= 0) return;
      const text = `From ${money.format(Math.round(base * rate * 100) / 100)} / roll`;
      if (label.textContent !== text) label.textContent = text;
    });
  }
  updatePrices();
  // Facet filtering, pagination and predictive search can replace card markup.
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches('[data-z-roll-start]') || node.querySelector('[data-z-roll-start]'))
    ))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; updatePrices(); });
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', updatePrices);
})();
